<template>
  <v-container fluid no-gutters ma-0 pa-0>
    <v-row class="mb-3" no-gutters>
     <v-text-field
            :placeholder="$t('common.search')"
            v-model="search"
            prepend-icon="$search"
            clearable
            class="mr-3"
          />
     <tag-create @create="addTag" :creating="creating" v-model="menu" />
    </v-row>
    <v-row v-if="loading" no-gutters justify="start">
        <v-skeleton-loader v-for="i in 8" :key="i" class="mx-1 mb-1" type="chip" />
    </v-row>
    <v-row v-else-if="visibleTags.length" no-gutters justify="start">
        <v-chip color="info" class="mx-1 mb-1" outlined v-for="t in visibleTags" :key="t.id" @click="clickTag(t)" :disabled="isDisabled(t.id)">
             <v-avatar left>
                <v-icon v-text="t.selected ? '$filterActive' : '$filterInactive'"></v-icon>
            </v-avatar>
            {{ t.name }}</v-chip>
    </v-row>
    <v-row v-else no-gutters justify="center">
        <p >{{ $t('campaigns.segment.tag.notFound')}}</p>
    </v-row>
  </v-container>
</template>

<script>

import TagCreate from '@/components/TagCreate'
import {mapState} from 'vuex'

export default {
    name: 'TagSelector',
    components: {TagCreate},
    props: {
        value: { type: [Array, String ]},
        domain: String,
        multiple: { type: Boolean },
        isDisabled:{ type: Function, default: () => false } 
    },
    data() {
        return {
            search: null,
            lastMarked: null,
            loading: false,
            creating: false,
            menu: false,
            marked: []
        }
    },
    watch: {
        /*
        value(nv) {
            this.tags.forEach(t => {
                if(nv.find(tt => tt.id = t.id )) {
                    t.selected = true;
                } else {
                    t.selected = false;
                }
            })
        }
        */
    },
    computed: {
        visibleTags() {
            if(!this.search) {
                return this.tags;
            }
            return this.tags.filter(t => t.name.indexOf(this.search) > -1 || t.selected == true); 
        },
         ...mapState('contacts', ['tags'])
    },
    methods: {
        async loadTags() {
            this.search=null;
            this.loading = true;
            await this.$store.dispatch('contacts/listTags', { domainID: this.domain, selected: this.value });
            this.lastMarked = this.value;
            this.loading = false;
        },
        clickTag(tag) {
            //console.debug('tag clicked', tag);
            if(this.multiple) {
                let i = this.marked.findIndex(t => t.id == tag.id);
                if(i !== -1) {
                    console.debug('unselecting', this.marked, tag.id);
                    tag.selected = false;
                    this.marked.splice(i, 1);
                } else {
                    console.debug('selecting', this.marked, tag.id);
                    this.marked.push(tag);
                    tag.selected = true;
                }
                this.$emit('input', this.marked);
            } else {
                if(this.lastMarked && this.lastMarked == tag.id) {
                    console.debug('unselecting', this.lastMarked, tag.id);
                    this.lastMarked = null;
                    tag.selected = false;
                } else if(this.lastMarked) {
                    console.debug('reselecting', this.lastMarked, tag.id);
                    let t = this.tags.find(t => t.id == this.lastMarked)
                    t.selected = false;
                    this.lastMarked = tag.id;
                    tag.selected = true;
                } else {
                    console.debug('selecting', this.lastMarked, tag.id);
                    this.lastMarked = tag.id;
                    tag.selected = true;
                }
                this.$emit('input', this.lastMarked);
            }
        },
        async addTag(newTagName) {
            this.creating = true;
            let nt = await this.$store.dispatch('domains/createTag', { name: newTagName });
            this.creating = false;
            this.menu = false;
            await this.loadTags();
            // selects the new tag automatically
            
            console.debug('automatically selecting the new tag', nt);
            // must find the instqance form the list of the loaded tags - cant pass the new object directly
            this.clickTag(this.tags.find(t=> t.id == nt.id));
        },
        reset() {
            console.debug('TagSelector resetting');
            this.tags.forEach(t => t.selected = false); 
        }
    },
    mounted() {
        this.loadTags();
    }
}
</script>

